import { render } from "./ExploreFirstPageConfig.vue?vue&type=template&id=23b77cc0&scoped=true"
import script from "./ExploreFirstPageConfig.vue?vue&type=script&lang=js"
export * from "./ExploreFirstPageConfig.vue?vue&type=script&lang=js"

import "./ExploreFirstPageConfig.vue?vue&type=style&index=0&id=23b77cc0&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b77cc0"]])

export default __exports__